// This file is generated by pnpm icons:generate. Do not edit.

import {CalendarDays_Stroke2_Corner0_Rounded as CanonicalCalendarDays_Stroke2_Corner0_Rounded} from './Calendar'

/** @deprecated Import CalendarDays_Stroke2_Corner0_Rounded from `#/components/icons/Calendar` instead. */
export const CalendarDays_Stroke2_Corner0_Rounded =
  CanonicalCalendarDays_Stroke2_Corner0_Rounded
